import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

import dsgvoStyle from 'src/theme/dsgvoStyle'

const useStyles = makeStyles((theme: Theme) => {

  return createStyles({

    /* -------------------------------------------------------------------------- */

    container: {
      paddingTop: theme.spacing(4),

      '& > hr': {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
      }
    },

    kontaktInfos: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(6),
      justifyContent: 'space-around',

      '& svg': {
        verticalAlign: 'sub',
        marginBottom: -2,
      },
    },

    /* -------------------------------------------------------------------------- */

    kontaktformular: {
      display: 'grid',
      gridTemplateAreas: `
        "c"
        "m"
        "d"
        "b"
      `,
      [theme.breakpoints.up('md')]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridTemplateAreas: `
          "c m"
          "d m"
          "d b"
        `,
      },
      gap: theme.spacing(3),
    },

    contactWrapper: {
      gridArea: 'c',
      display: 'flex',
      flexWrap: 'wrap',
      alignContent: 'flex-start',
      alignItems: 'flex-start',
      gap: theme.spacing(3),
    },

    dsgvoWrapper: {
      gridArea: 'd',
    },

    telefonWrapper: {
      marginBottom: theme.spacing(3),
    },

    messageWrapper: {
      gridArea: 'm',
    },

    buttonWrapper: {
      gridArea: 'b',
    },

    messageField: {
    },

    dsgvoForm: {
      ...dsgvoStyle(theme, {switch: true}),
      marginBottom: theme.spacing(3),
    },
    dsgvoRecaptcha: dsgvoStyle(theme),

    dsgvoError: {
      color: `var(--page-builder-error, ${theme.palette.error.main})`,
    },

    /* -------------------------------------------------------------------------- */

    gesendet: {
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(2),
      marginTop: theme.spacing(3),

      '& > p': {
        marginTop: theme.spacing(3),
      },

      '& > hr': {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
      },
    },

    error: {
      border: `1px solid var(--page-builder-error, ${theme.palette.error.main})`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(6),
      marginTop: theme.spacing(3),

      textAlign: 'center',
      '& button': {
        marginTop: theme.spacing(3),
      },
    },

    /* -------------------------------------------------------------------------- */

  })
})

export default useStyles
